// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-ZXaS8 {\n  display: flex;\n  align-items: center;\n  margin: 0 15px 2px;\n  padding: 0;\n  list-style: none;\n  border-right: 4px solid transparent;\n  transition: all 0.2s ease 0s;\n  font: 14px/30px \"Open Sans Eas\";\n  cursor: pointer;\n}\n.list-jW1aA:empty {\n  height: 38px;\n  position: relative;\n  cursor: default;\n}\n.list-jW1aA:empty:after {\n  font-size: 12px;\n  content: attr(data-empty);\n  color: #8b91a0;\n  position: absolute;\n  left: 30px;\n  top: 10px;\n}\n.checkbox-BaG1u {\n  flex: 1;\n  line-height: 1;\n  padding: 0 15px 0 10px;\n  overflow: hidden;\n}\n.checkbox-BaG1u label {\n  font-weight: normal;\n  height: 30px;\n  line-height: 30px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0;\n  margin: 0;\n  display: inherit;\n  color: #6b546a;\n}\n.checkbox-BaG1u label:hover {\n  font-weight: bold;\n}\n.checkbox-BaG1u label:before {\n  content: \"V\";\n  color: #8b91a0;\n  font-family: \"eas-icomoon\";\n  font-size: 17px;\n  position: relative;\n  bottom: -2px;\n  background: none;\n  width: auto;\n  height: auto;\n  left: 0;\n  border: none;\n  top: 3px;\n  margin-right: 5px;\n}\n.checkbox-BaG1u label:after {\n  display: none;\n}\n.checkbox-BaG1u label.checked:before {\n  content: \"X\";\n  color: #8b91a0;\n  font-family: \"eas-icomoon\";\n  font-size: 17px;\n  width: auto;\n  height: auto;\n  position: relative;\n  bottom: -2px;\n  background: none;\n  left: 0;\n  border: none;\n}\n.checkbox-BaG1u label.checked:after {\n  display: none;\n}\n.badge-Acl\\+H {\n  font: 600 12px/15px \"Open Sans Eas\";\n  right: 40px;\n  min-width: 10px;\n  padding: 3px 7px;\n  color: #fff;\n  vertical-align: middle;\n  white-space: nowrap;\n  text-align: center;\n  border-radius: 10px;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/sidebar-filter/checkbox-list/styles.less"],"names":[],"mappings":"AAEA;EAEI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,mCAAA;EACA,4BAAA;EACA,+BAAA;EACA,eAAA;AA8GJ;AA1GI;EACE,YAAA;EACA,kBAAA;EACA,eAAA;AA4GN;AA1GI;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AA4GN;AArIA;EA8BI,OAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AA0GJ;AA3IA;EAmCM,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;AA2GN;AA1GM;EACE,iBAAA;AA4GR;AA1GM;EACE,YAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;AA4GR;AA1GM;EACE,aAAA;AA4GR;AAtGU;EACE,YAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,OAAA;EACA,YAAA;AAwGZ;AAtGU;EACE,aAAA;AAwGZ;AA5LA;EA4FI,mCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAmGJ","sourcesContent":["@import \"@cirrus/legacy/app-components/app/styles/colors/colors-default.less\";\n\n:local {\n  .item {\n    display: flex;\n    align-items: center;\n    margin: 0 15px 2px;\n    padding: 0;\n    list-style: none;\n    border-right: 4px solid transparent;\n    transition: all 0.2s ease 0s;\n    font: 14px/30px \"Open Sans Eas\";\n    cursor: pointer;\n  }\n\n  .list {\n    &:empty {\n      height: 38px;\n      position: relative;\n      cursor: default;\n    }\n    &:empty:after {\n      font-size: 12px;\n      content: attr(data-empty);\n      color: @clr-gray-855;\n      position: absolute;\n      left: 30px;\n      top: 10px;\n    }\n  }\n\n  .checkbox {\n    flex: 1;\n    line-height: 1;\n    padding: 0 15px 0 10px;\n    overflow: hidden;\n    label {\n      font-weight: normal;\n      height: 30px;\n      line-height: 30px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      padding: 0;\n      margin: 0;\n      display: inherit;\n      color: @clr-gray-350;\n      &:hover {\n        font-weight: bold;\n      }\n      &:before {\n        content: \"V\";\n        color: @clr-gray-855;\n        font-family: \"eas-icomoon\";\n        font-size: 17px;\n        position: relative;\n        bottom: -2px;\n        background: none;\n        width: auto;\n        height: auto;\n        left: 0;\n        border: none;\n        top: 3px;\n        margin-right: 5px;\n      }\n      &:after {\n        display: none;\n      }\n    }\n    :global {\n      label {\n        &.checked {\n          &:before {\n            content: \"X\";\n            color: @clr-gray-855;\n            font-family: \"eas-icomoon\";\n            font-size: 17px;\n            width: auto;\n            height: auto;\n            position: relative;\n            bottom: -2px;\n            background: none;\n            left: 0;\n            border: none;\n          }\n          &:after {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n\n  .badge {\n    font: 600 12px/15px \"Open Sans Eas\";\n    right: 40px;\n    min-width: 10px;\n    padding: 3px 7px;\n    color: @clr-white;\n    vertical-align: middle;\n    white-space: nowrap;\n    text-align: center;\n    border-radius: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"item": "item-ZXaS8",
	"list": "list-jW1aA",
	"checkbox": "checkbox-BaG1u",
	"badge": "badge-Acl+H"
};
export default ___CSS_LOADER_EXPORT___;
